import { render, staticRenderFns } from "./Counts.vue?vue&type=template&id=afefd522&scoped=true"
import script from "./Counts.vue?vue&type=script&lang=js"
export * from "./Counts.vue?vue&type=script&lang=js"
import style0 from "./Counts.vue?vue&type=style&index=0&id=afefd522&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afefd522",
  null
  
)

export default component.exports